import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';

import api from '../../../../../utils/API';
import { CreateCustomSegmentDTO, CustomSegmentParams } from './types';
import { ChainFilterBody } from './hooks/useChainFilter';

const BASE_URL = `${process.env.REACT_APP_ISA_SETUP_URL}/custom-segment`;
let cancelTokenFiltros;

export const getCustomSegment = (params?: CustomSegmentParams) =>
  trackPromise(
    api({
      url: BASE_URL,
      method: 'GET',
      params,
      expectToken: true,
    }).then(resp => resp),
    'custom-segment',
  );

export const saveCustomSegment = (data: CreateCustomSegmentDTO) =>
  trackPromise(
    api({
      url: `${BASE_URL}/save`,
      method: 'POST',
      data,
      expectToken: true,
      validateStatus: null,
    }).then(resp => resp),
    'custom-segment',
  );

export const updateCustomSegment = (id: number, data: CreateCustomSegmentDTO) =>
  trackPromise(
    api({
      url: `${BASE_URL}/${id}`,
      method: 'PUT',
      data,
      expectToken: true,
    }).then(resp => resp),
    'custom-segment',
  );

export const deleteCustomSegment = (id: number) =>
  trackPromise(
    api({
      url: `${BASE_URL}`,
      method: 'DELETE',
      params: {
        idSegmentoPersonalizado: id,
      },
      expectToken: true,
    }).then(resp => resp),
    'custom-segment',
  );

export const getItensFiltros = (data: ChainFilterBody) => {
  if (cancelTokenFiltros !== undefined) {
    cancelTokenFiltros.cancel('Operation canceled due to new request.');
  }

  cancelTokenFiltros = axios.CancelToken.source();

  return trackPromise(
    api({
      url: `${process.env.REACT_APP_CLIENTE_URL}/painel_geral/filtros`,
      method: 'POST',
      data: JSON.stringify(data),
      cancelToken: cancelTokenFiltros.token,
      expectToken: true,
    }).then(resp => resp),
    'segment-chain-filter',
  );
};
